module.exports = __webpack_public_path__ + "img/account_open.4f764e93.svg";